import { IconBigDrop, IconLeak, IconThreeDrops } from '../../../../../../../assets/control-icons';
import { ChannelIconTypeEnum, AvailableIcon } from '../../../../../../../types';

export const floodIcons = (isOn?: boolean): AvailableIcon[] => [
  {
    iconName: '',
    component: <IconLeak isOn={isOn !== undefined ? isOn : true} />,
    oldIconName: 'DEVICE_ICON_24',
  },
  {
    iconName: ChannelIconTypeEnum.ICON_BIG_DROP,
    component: <IconBigDrop isOn={isOn !== undefined ? isOn : true} />,
    oldIconName: 'DEVICE_ICON_27',
  },
  {
    iconName: ChannelIconTypeEnum.ICON_THREE_DROPS,
    component: <IconThreeDrops isOn={isOn !== undefined ? isOn : true} />,
    oldIconName: 'DEVICE_ICON_28',
  },
];
